import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData,
  type UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError,
  type UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse,
  uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost,
} from '../../generated';

export type UploadImageToCollectionMutationVariables =
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData['path'] &
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData['body'];

export type UploadImageToCollectionMutation =
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse;

export const useUploadImageToCollectionMutation = <
  TError = UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UploadImageToCollectionMutation, TError, UploadImageToCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UploadImageToCollectionMutation, TError, UploadImageToCollectionMutationVariables, TContext>({
    mutationKey: ['UploadImageToCollection'],
    mutationFn: async ({ portfolio_id, collection_id, ...body }: UploadImageToCollectionMutationVariables) => {
      const { data } =
        await uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost({
          path: { portfolio_id, collection_id },
          body,
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useUploadImageToCollectionMutation.fetcher = (
  { portfolio_id, collection_id, ...body }: UploadImageToCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost({
      path: { portfolio_id, collection_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
